import React from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import Badge from '@components/ringil3/Badges/Badge';
import { formatPieces, isNotNullOrUndefined } from '@utils/utils';

interface ComponentProps {
  id: string;
}

const IDBadge: React.FC<ComponentProps> = ({ id }) => {
  const { tr } = useTranslationLgs();
  return (
    <>
      {isNotNullOrUndefined(id) && (
        <Badge filled={false} value={id} highlightedValue={false} label={tr(`IDBadge.label`, `ID`)}></Badge>
      )}
    </>
  );
};

export default IDBadge;
